import LoadingLogoImg from "../Images/Untitled.png"

function LoadingLogo() {

    return (
        <>
            <div className="LoadingLogo" id="LoadingLogo-id">
                <div className="LoadingLogo-inborder">
                    <span className="LoadingLogo-MD">
                        MD
                    </span>
                    <span>
                        Pharmacy
                    </span>
                    <span className="LoadingLogo-Loader">
                        <div className="LoadingLogo-Loaderpng"></div>
                    </span>
                </div>
            </div>
        </>
    );
}

export default LoadingLogo;